const initialState = {
  newOrganizationComplianceListForm: false,
  cplId: '',
  cplOrgId: '',
  ReferenceNumber: '',
  complianceCategoryId: '',
  complianceDescriptionId: '',
  description: '',
  startDate: '',
  endDate: '',
};
export default initialState;
